// Basic wrapper for local storage api, which safely handles the case where the local storage is full or have an error when setting an item
// Later we should add more capabilities like user context, expiration,etc.

export const createLocalStorageProvider = (namespace: string) => {
	const getLocalStorage = () => {
		try {
			return window.localStorage;
		} catch (e) {
			console.error('Local storage is not available', e);
			return null;
		}
	};

	const getKey = (key: string) => {
		return `${namespace}-${key}`;
	};

	const setItem = (key: string, value: string) => {
		try {
			getLocalStorage()?.setItem(getKey(key), value);
		} catch (e) {
			console.error('Failed to set item', e);
		}
	};

	const removeItem = (key: string) => {
		getLocalStorage()?.removeItem(getKey(key));
	};

	const clear = () => {
		getLocalStorage()?.clear();
	};

	const getItem = (key: string) => {
		return getLocalStorage()?.getItem(getKey(key));
	};

	return {
		setItem,
		removeItem,
		clear,
		getItem,
	};
};
